export const logMessageEval=(message, messageItem)=> {

    if (message !== undefined) {

        let text = "`" + message + "`";
        let msg = eval(text);

        return msg
    } else {

        return ''

    }
}
export const evalLicenseToShowText = (name, noOfTimeTableToShowIndex, index) => {

    if (name != undefined) {
        if (noOfTimeTableToShowIndex >= index) {
            return name
        }
        else {
            return "***"
        }
    }
}
export const calculateBlur = (percentage, timeTable, maxNumberOfItemDisplayForTrialUser) =>{
    if (percentage != 1) {
        let noOfTimeTableToDisplay = Math.round(timeTable.length * percentage)
        let displayCount = Math.min(noOfTimeTableToDisplay, maxNumberOfItemDisplayForTrialUser)
        return (displayCount - 1)
    }
    else {
        return ((Math.round(timeTable.length * percentage)) - 1)
    }
}